module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_dk_10share_btn_activated.51287b0d.png";